<template>
    <div>
        <div id="category-chart"></div>
    </div>
</template>
<script>
    import ApexCharts from 'apexcharts';

    export default {
        name: 'user-group-bar-chart',
        props: {
            chartData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                options: {
                    title: {
                        text: 'Testu rezultāti pēc kategorijām'
                    },
                    series: this.chartData.series,
                    colors:['#b8d8d8', '#7a9e9f'],
                    chart: {
                        type: 'bar',
                        height: 350,
                        stacked: true,
                        stackType: '100%'
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        },
                    },
                    xaxis: {
                        categories: this.chartData.labels,
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val
                            }
                        }
                    },
                    fill: {
                        opacity: 1

                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'left',
                        offsetX: 40
                    }
                }
            }
        },
        mounted() {
            let chart = new ApexCharts(document.querySelector("#category-chart"), this.options);
            chart.render();
        }
    }
</script>